import { Stack } from '@mui/material';
import { ClaimEventResponseItem } from 'API/claimEvent';
import { TextIntro } from './TextIntro';
import { SectionItem } from './SectionItem';

interface ISections {
  claimEvent: ClaimEventResponseItem[];
}

export const Sections = ({ claimEvent }: ISections) => {
  return (
    <>
      <TextIntro numberOfSections={claimEvent.length} />
      <Stack gap='16px'>
        {claimEvent.map((claimEvent: ClaimEventResponseItem, index: number) => {
          return <SectionItem key={index} claimEvent={claimEvent} />;
        })}
      </Stack>
    </>
  );
};
